import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav ul li").eq(6).addClass("active");
$(".content-nav a").eq(1).addClass("active");
// var joinPic = new Swiper(".join .right .mySwiper", {
    
// })
var joinText = new Swiper(".join .container .mySwiper", {
    navigation: {
        nextEl: ".join .swiper-button-next",
        prevEl: ".join .swiper-button-prev",
      },
})
joinPic.controller.control = joinText;//Swiper1控制Swiper2，需要在Swiper2初始化后
joinText.controller.control = joinPic;//Swiper2控制Swiper1，需要在Swiper1初始化后
$(".swiper-button").click(function() {
    $(this).addClass("active").siblings().removeClass("active");
})